import React, { useEffect, useState } from 'react';
import api from 'services/api';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEye, faClock } from '@fortawesome/free-solid-svg-icons';

interface IStatistics {
  channelId?: string;
  videoHashId: string;
  channelName?: string;
}

function VideoStatistics({ channelId, videoHashId, channelName }: IStatistics) {
  const [stats, setStats] = useState(null as any);
  const [loading, setLoading] = useState<boolean>(true);

  const url =
    channelId !== 'home' ? `api/videos/${videoHashId}/stats/?channel=${channelId}` : `api/videos/${videoHashId}/stats/`;
  useEffect(() => {
    const fetchData = () => {
      api.get(url).then((resp: any) => {
        setStats(resp.data);
        setLoading(false);
      });
    };

    fetchData();
  }, [channelId, videoHashId]);

  if (loading) {
    return (
      <div className="h-full w-full flex flex-col flex-1 overflow-y-auto">
        <div className="shadow rounded-lg py-4 text-xs">
          <div className="space-y-6">
            {/* Skeleton for Internal Viewers */}
            <div>
              <div className="h-3 bg-gray-200 rounded w-1/3 mb-3"></div>
              <div className="space-y-3">
                <div className="flex items-center text-black font-lato">
                  <div className="bg-gray-200 w-6 h-6 rounded-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 ml-2"></div>
                </div>
                <div className="flex items-center text-black font-lato">
                  <div className="bg-gray-200 w-6 h-6 rounded-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 ml-2"></div>
                </div>
                <div className="flex items-center text-black font-lato">
                  <div className="bg-gray-200 w-6 h-6 rounded-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 ml-2"></div>
                </div>
              </div>
            </div>

            {/* Skeleton for External Viewers */}
            <div>
              <div className="h-3 bg-gray-200 rounded w-1/3 mb-3"></div>
              <div className="space-y-3">
                <div className="flex items-center text-black font-lato">
                  <div className="bg-gray-300 w-6 h-6 rounded-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 ml-2"></div>
                </div>
                <div className="flex items-center text-black font-lato">
                  <div className="bg-gray-300 w-6 h-6 rounded-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 ml-2"></div>
                </div>
                <div className="flex items-center text-black font-lato">
                  <div className="bg-gray-300 w-6 h-6 rounded-full"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 ml-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full w-full flex flex-col flex-1 overflow-y-auto">
      <div className="shadow rounded-lg py-4 text-xs">
        <div className="space-y-6">
          {/* Internal Viewers */}
          <div>
            <h3 className="text-sm font-semibold mb-3">
              Viewing statistics in {channelName ? `#${channelName}` : 'Workspace'}
            </h3>
            <div className="space-y-3">
              <div className="flex items-center text-black font-lato">
                <FontAwesomeIcon icon={faUser} className="text-slate-700 w-6" />
                <span>Unique Viewers:</span>
                <span className="ml-auto">{stats?.internal?.unique_viewers}</span>
              </div>
              <div className="flex items-center text-black font-lato">
                <FontAwesomeIcon icon={faEye} className="text-slate-700 w-6" />
                <span>Total Views:</span>
                <span className="ml-auto">{stats?.internal?.total_views}</span>
              </div>
              <div className="flex items-center text-black font-lato">
                <FontAwesomeIcon icon={faClock} className="text-slate-700 w-6" />
                <span>Avg Viewing Duration:</span>
                <span className="ml-auto">{stats?.internal?.average_viewing_duration}</span>
              </div>
            </div>
          </div>

          {/* External Viewers */}
          <div>
            <h3 className="text-sm font-semibold mb-3">External Statistics</h3>
            <div className="space-y-3">
              <div className="flex items-center text-black font-lato">
                <FontAwesomeIcon icon={faUser} className="text-slate-700 w-6" />
                <span>Unique Viewers:</span>
                <span className="ml-auto">{stats?.external?.unique_viewers}</span>
              </div>
              <div className="flex items-center text-black font-lato">
                <FontAwesomeIcon icon={faEye} className="text-slate-700 w-6" />
                <span>Total Views:</span>
                <span className="ml-auto">{stats?.external?.total_views}</span>
              </div>
              <div className="flex items-center text-black font-lato">
                <FontAwesomeIcon icon={faClock} className="text-slate-700 w-6" />
                <span>Avg Viewing Duration:</span>
                <span className="ml-auto">{stats?.external?.average_viewing_duration}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoStatistics;
